import { Injectable } from '@angular/core';
import { ReCaptchaV3Service } from 'ng-recaptcha-angular19';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CaptchaService {

  constructor(private recaptchaV3: ReCaptchaV3Service) { }

   /**
   * executeAction - runs reCAPTCHA v3 for the provided action
   * @param action e.g. 'access_certificate' or 'recover_candidate_number'
   * @returns promise that resolves to token string
   */

  executeAction(action: string): Promise<string> {
    return firstValueFrom(this.recaptchaV3.execute(action));
  }
}
